import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import komity_icon from '../../imgs/komity_icon.png';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../App.css';

export default function AdminLogin({ onBusinessLinked, setLogin, setNegocioId }) {
    const historial = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    // ============================================================
    // 🚩 EL ANTÍDOTO PARA LA FRANJA BLANCA Y RESPONSIVO
    // ============================================================
    useEffect(() => {
        // Forzamos a que el body no tenga espacio arriba
        const originalPadding = document.body.style.paddingTop;
        document.body.style.setProperty("padding-top", "0px", "important");
        
        // Evitamos que el body haga scroll raro en el login
        document.body.style.overflow = "hidden";

        return () => {
            // Al salir, devolvemos el estado original para el menú
            document.body.style.paddingTop = originalPadding;
            document.body.style.overflow = "auto";
        };
    }, []);

    const handleAdminLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) return toast.warning("Por favor, completa todos los campos");
        setLoading(true);
        try {
            const urlBase = (config.api_url || "http://localhost:5000").replace(/\/$/, "");
            const res = await axios.post(urlBase + "/api/auth/admin-login", { 
                email: email.trim(), 
                password: password.trim() 
            });
            
            if (res.data && res.data.status === "success") {
                localStorage.setItem("negocioId", res.data.negocioId);

                // 🚩 Sin staff configurado no existe ningún PIN, así que mandar
                // al PIN screen es un callejón sin salida. Para cualquier plan,
                // si no hay staff, entramos directo a la app con la sesión
                // del admin (email+clave ya es auth suficiente).
                if (!res.data.tieneStaff) {
                    setNegocioId(res.data.negocioId);
                    setLogin({
                        token: res.data.token,
                        usuario: { nombre: res.data.nombre, rol: 'ADMIN' },
                        config: null
                    });
                    toast.success("¡Bienvenido, " + res.data.nombre + "!");
                    historial.push("/home/");
                    return;
                }

                localStorage.setItem("token", res.data.token);
                toast.success("✅ Dispositivo vinculado");
                onBusinessLinked(res.data.negocioId);
            } else {
                toast.error("❌ " + (res.data.message || "Error de acceso"));
            }
        } catch (err) {
            console.error("Error Login:", err);
            toast.error("⚠️ No se pudo conectar con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="adminlogin-wrapper">
            <style>{`
                .adminlogin-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                    width: 100vw;
                    position: fixed;
                    top: 0;
                    left: 0;
                    padding: 20px;
                    box-sizing: border-box;
                    background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
                    overflow: hidden;
                }
                .adminlogin-wrapper::before {
                    content: '';
                    position: absolute;
                    width: 600px;
                    height: 600px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(122,39,245,0.18) 0%, transparent 70%);
                    top: -200px;
                    right: -200px;
                    animation: adminlogin-float 8s ease-in-out infinite;
                }
                .adminlogin-wrapper::after {
                    content: '';
                    position: absolute;
                    width: 400px;
                    height: 400px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(252,25,88,0.14) 0%, transparent 70%);
                    bottom: -100px;
                    left: -100px;
                    animation: adminlogin-float 10s ease-in-out infinite reverse;
                }
                @keyframes adminlogin-float {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    50% { transform: translate(30px, -30px) scale(1.1); }
                }
                .adminlogin-btn {
                    width: 100%;
                    border: none;
                    color: #fff;
                    font-weight: 700;
                    background: linear-gradient(135deg, #7A27F5, #FC1958);
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .adminlogin-btn:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 8px 20px rgba(122,39,245,0.35);
                }
                .adminlogin-btn:disabled { opacity: 0.7; }
            `}</style>

            {/* TARJETA DE LOGIN */}
            <div className='card shadow-lg text-center' style={{
                zIndex: 2,
                width: '100%',
                maxWidth: '420px',
                borderRadius: '28px',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(20px)',
                border: 'none',
                padding: '40px 30px',
                boxShadow: '0 25px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)'
            }}>
                {/* LOGO KOMITY */}
                <div className="mb-3" style={{ width: '64px', height: '64px', margin: '0 auto', borderRadius: '18px', overflow: 'hidden', boxShadow: '0 8px 20px rgba(122,39,245,0.25)' }}>
                    <img src={komity_icon} alt="Komity" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>

                <h3 className="font-weight-bold mb-1" style={{ color: '#1a1a1a', letterSpacing: '-0.5px' }}>Bienvenido</h3>
                <p style={{ color: '#888', fontSize: '14px' }} className="mb-4">Inicia sesión para autorizar este equipo</p>

                <form onSubmit={handleAdminLogin}>
                    
                    {/* INPUT CORREO */}
                    <div className="komity-input-group mb-3">
                        <i className="bi bi-envelope komity-input-icon"></i>
                        <input
                            type="email"
                            className="form-control komity-input"
                            style={{ height: '55px', fontSize: '15px' }}
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                    {/* INPUT CONTRASEÑA */}
                    <div className="komity-input-group mb-2">
                        <i className="bi bi-lock komity-input-icon"></i>
                        <input
                            type="password"
                            className="form-control komity-input"
                            style={{ height: '55px', fontSize: '15px' }}
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                    {/* OLVIDÓ CONTRASEÑA */}
                    <div className="text-right mb-4">
                        <a href="/usuario/recupera/" style={{ fontSize: '11px', color: '#aaa', textDecoration: 'none', fontWeight: 'bold' }}>
                            ¿OLVIDASTE TU CONTRASEÑA?
                        </a>
                    </div>

                    {/* BOTÓN PRINCIPAL */}
                    <button
                        type="submit"
                        className="adminlogin-btn py-3 shadow"
                        style={{ fontSize: '16px', borderRadius: '50px' }}
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                            <span><i className="bi bi-link-45deg mr-1"></i> Vincular Dispositivo</span>
                        )}
                    </button>
                </form>

                <div className="mt-4">
                    <small style={{ color: '#ccc', fontSize: '11px', fontWeight: '500' }}>KOMITY CLOUD POS v2.1</small>
                </div>
            </div>

            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
}

